export default __webpack_public_path__ + "static/media/2-mobile.ca141241.png";